export default "__VITE_PUBLIC_ASSET__80496d2d__"